import { render, staticRenderFns } from "./userpage.vue?vue&type=template&id=3b939de1&"
import script from "./userpage.vue?vue&type=script&lang=js&"
export * from "./userpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports